<template>
    <div id="outcomes_label">
        <p id="outcomes_text">{{section}}</p>
    </div>
    <div id="labels">
        <div id="forest_label">
            <p id="forest_text_sp">Forest</p>
        </div>
        <div id="traditional_label">
            <p id="traditional_text_sp">Traditional</p>
        </div>
    </div>
    <div id="graphs">
        <div id="forest_graph">
            <svg id="forest_sp1" :viewBox="vb">
                <a v-for="(i,index) in outcomes_forest"
                :key="i.Topic" :href="i.Source" target="_blank">
                    <path class="Leaf"
                    d="M14.84,112.56,25.05,94.69l5.56-46.77a23.3,23.3,0,0,1,19.73-20.3L148.86,13,137.39,92.78a23.32,23.32,0,0,1-25.63,19.86L41.65,104.9Z"
                    :transform="position(i.Corrected,index)"
                    :style="color(i, index)">
                        {{index}}
                    </path>
                    <text class="Leaf_text"
                    :x="x(i.Corrected,index)" :y="y(i.Corrected,index)"
                    :style="text_size(i.Corrected)">
                        {{label(i.Display)[0]}}
                        <tspan class="Leaf_text" dy="1.1em" :x="x(i.Corrected,index)">{{label(i.Display)[1]}}</tspan>
                        <tspan class="Leaf_text" dy="1.1em" :x="x(i.Corrected,index)">{{label(i.Display)[2]}}</tspan>
                    </text>
                </a>
            </svg>
        </div>
        <div id="traditional_graph">
            <svg id="traditional_sp1" :viewBox="vb">
                <a v-for="(i,index) in outcomes_trad"
                :key="i.Topic" :href="i.Source" target="_blank">
                    <path class="Leaf"
                    d="M14.84,112.56,25.05,94.69l5.56-46.77a23.3,23.3,0,0,1,19.73-20.3L148.86,13,137.39,92.78a23.32,23.32,0,0,1-25.63,19.86L41.65,104.9Z"
                    :transform="position(i.Corrected,index)"
                    :style="color(i, index)">
                        {{index}}
                    </path>
                    <text class="Leaf_text"
                    :x="x(i.Corrected,index)" :y="y(i.Corrected,index)"
                    :style="text_size(i.Corrected)">
                        {{label(i.Display)[0]}}
                        <tspan class="Leaf_text" dy="1.1em" :x="x(i.Corrected,index)">{{label(i.Display)[1]}}</tspan>
                        <tspan class="Leaf_text" dy="1.1em" :x="x(i.Corrected,index)">{{label(i.Display)[2]}}</tspan>
                    </text>
                </a>
            </svg>
        </div>
    </div>
    <div style="padding-top:51%">
        <p id="context" style="padding:1%">The above elements represent the approximate findings from a selection of research studies comparing results between groups of adolescents
        exposed to different natural elements and groups in indoor or less green settings. To read the full research paper, click on the relevant topic, and you will be linked
        to it's published site.</p>
    </div>
</template>

<script>
import { scaleLinear } from 'd3-scale';

export default {
  name: 'programs',
  props: ['outcomes_forest','outcomes_trad','section'],
  computed: {
    vb: function(){
        if (this.outcomes_forest.length == 4){
            return "0 0 700 600"
        } else {
            return "0 0 700 500"
        }
    }
  },
  methods: {
      position: function(value, index) {
        if (index%2 == 0){
            const translate = "translate(400,"+ index*200/(value) +")"
            const scale = "scale("+value+")"
            const flip = "scale(-1,1)"
            
            return translate + " " + scale + " " + flip   
        } else {
            const translate = "translate(325,"+ index*200/(value) +")"
            const scale = "scale("+value+")"
            const flip = ""
            
            return translate + " " + scale + " " + flip
        }
      },
      x: function(value, index){
         if (index%2 == 0){
            return 365+(134.02*value)/-2  
        } else {
            return 360+(134.02*value)/2
        } 
      },
      y: function(value, index){
        return index*200/(value) + 99.78*value/1.95
      },
      label: function(value){
          return value.split("_")
      },
      text_size: function(value){
        const scale = scaleLinear()
          .domain([1.42, 2])
          .range([20, 32]);
    
        return "font-size:"+scale(value)+"px"
      },
      color: function(value, index) {
        var val = value.Corrected
        if (["Punishment","Stress","Obesity","Respiratory"].includes(value.Topic)){
            const mn = Math.min(this.outcomes_forest[index].Corrected,this.outcomes_trad[index].Corrected)
            const scale1 = scaleLinear()
              .domain([mn+.58, mn])
              .range(["#806443", "#839788"]);
            
            return "fill:"+scale1(val)
        } else {
            const scale = scaleLinear()
            .domain([1.42, 2])
              .range(["#806443", "#839788"]);  
            
            return "fill:"+scale(val)
        }
      }
  },
  components: {
  },
  setup() {
  }
}
</script>

<style>
#outcomes_label {
    width: 100%;
}

#outcomes_text {
    color: 	white;
    font-family: Josefin;
    font-size: 2.2vw;
    background-color: #839788d9;
    text-align: center;
    margin: auto;
    width: 10%;
    padding: 5px;
}

#forest_text_sp, #traditional_text_sp {
    color: 	white;
    font-family: Josefin;
    font-size: 2vw;
    /*background-color: #666666;*/
    /*opacity: .85;*/
    text-align: center;
    margin: auto;
    width: 15%;
    padding-top: 1%;
    padding-bottom: 2%;
}

.Leaf_text {
    fill: 	white;
    font-family: Josefin;
    text-anchor: middle;
}

.Leaf {
    opacity: .85;
}


.Leaf:hover {
    opacity: 1;
}
</style>
